<template>
  <v-container grid-list-xl fluid>
    <v-layout row wrap>
      <v-overlay :value="pageLoading">
        <v-progress-circular indeterminate size="64"></v-progress-circular>
      </v-overlay>
      <v-container class="grey lighten-5">
        <v-row no-gutters class="pagination-table-header">
          <v-col
            col="12"
          >
            <v-overlay
              :absolute="true"
              :value="pageLoading"
            >
              <v-progress-circular indeterminate size="24"></v-progress-circular>
            </v-overlay>
            <v-card
              style="width:100%"
              v-if="L.isEmpty(paginatedObject) || L.isEmpty(paginatedObject.data)"
              class="pa-3">
              <p class="text-center mt-2">
                <v-icon>mdi-account-search-outline</v-icon>
                <b>{{ $t('announcement.not_found') }}</b>
                <v-icon>mdi-account-badge-outline</v-icon>
              </p>
            </v-card>
            <div v-else>
              <v-card
                v-for="(item, key) in paginatedObject.data"
                :key="key"
                class="mx-auto pa-2 mb-2"
                style="width:100%"
                outlined
              >
                <v-list-item>
                  <v-list-item-content class="">
                    <v-list-item-subtitle class="">
                      {{ item.data.title }}; {{ item.data.text }}
                    </v-list-item-subtitle>
                    <v-list-item-subtitle class="" style="text-align: right;">
                      <b>{{
                          moment.utc(item.created_at)
                            .local()
                            .format(DATETIME_VIEW)
                        }}
                        {{ item.data.author }}</b>
                    </v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
              </v-card>
            </div>
          </v-col>
        </v-row>
      </v-container>

      <v-flex v-if="!pageLoading">
        <pagination-listing
          :pagination-data="paginationData"
          @go-prev="changePage('-')"
          @go-next="changePage('+')"
        ></pagination-listing>
      </v-flex>
      <modal-loading :is-show="isTableLoading"></modal-loading>
    </v-layout>
  </v-container>
</template>

<script>
import defaultListingMixin from '@/mixins/listing/defaultListingMixin';
import updatePageContentMixin from '@/mixins/updatePageContentMixin';
import paginationMixin from '@/mixins/listing/paginationMixin';
import ModalLoading from '@/components/loaders/ModalLoading.vue';
import PaginationListing from '@/components/listings/PaginationListing.vue';
import { MANAGER_TOP } from '@/constants/roles';
import { PER_PAGE_NOTIFICATIONS } from '@/constants/listing';
import NotificationProxy from '@/proxies/Notifications/NotificationProxy';
import _ from 'lodash';
import moment from 'moment';
import { DATETIME_VIEW } from '@/constants/dates';

export default {
  name: 'NotificationBoard',
  mixins: [
    defaultListingMixin,
    updatePageContentMixin,
    paginationMixin,
  ],
  components: {
    ModalLoading,
    PaginationListing,
  },
  data() {
    return {
      moment,
      DATETIME_VIEW,
      /* Page management */
      L: _,
      pageLoading: false,
      MANAGER_TOP,
      /* Listing management */
      isTableLoading: false,
      searchParams: {
        page: {
          number: 1,
          size: PER_PAGE_NOTIFICATIONS,
        },
      },
    };
  },
  created() {
    this.isTableLoading = true;
    this.fetchData();
  },
  methods: {
    fetchData() {
      this.isRequestingNow = true;
      new NotificationProxy()
        .setParameters(this.searchParams)
        .listBoard()
        .then((response) => {
          this.paginatedObject = response.data.data.notifications;
        })
        .catch((error) => {
          console.warn(error);
          this.paginatedObject = {};
        })
        .finally(() => {
          this.isTableLoading = false;
          this.isRequestingNow = false;
          this.$store.dispatch('page/finishUpdateCurrentPageContent');
        });
    },
  },
};
</script>

<style scoped>

</style>
